export const TIME_PRESETS = [
  { label: "Full Day", start: "09:00", end: "18:00" },
  { label: "Half Day", start: "09:00", end: "13:00" },
  { label: "Afternoon", start: "14:00", end: "18:00" },
];

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const yesterdayStr = () => {
  const d = new Date(Date.now() - 86400000);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const extractTime = (isoString) => {
  if (!isoString) return "";
  if (isoString.includes("T")) return isoString.split("T")[1].substring(0, 5);
  return isoString;
};

export const calcHours = (start, end) => {
  if (!start || !end) return 0;
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  const mins = eh * 60 + em - (sh * 60 + sm);
  return mins > 0 ? mins / 60 : 0;
};

export const formatHrs = (h) => (h > 0 ? `${h.toFixed(2)} hrs` : "—");

export const timeOptions = (() => {
  const options = [];
  for (let hour = 9; hour <= 20; hour++) {
    for (const min of ["00", "30"]) {
      if (hour === 20 && min === "30") continue;
      options.push(`${String(hour).padStart(2, "0")}:${min}`);
    }
  }
  return options;
})();

export const WORKLOG_NOTE_OTHER = "Others";

export const WORKLOG_NOTE_OPTIONS = [
  "Tender screening",
  "Tender add",
  "Doc preparation",
  "CV sourcing",
  "CV formatting",
  "BG preparation",
  "Representation",
  "Presentation/preparation",
  "Hardcopy submission",
  "Technical/Financial upload",
  WORKLOG_NOTE_OTHER,
];

export const emptyWorklogRow = () => ({
  _id: crypto.randomUUID(),
  taskId: null,
  projectId: "",
  activityId: "",
  subActivityId: "",
  startTime: "",
  endTime: "",
  workType: "",
  noteOption: "",
  note: "",
  description: "",
  isSelected: true,
});

export const projectDisplayName = (p) =>
  p?.short_name || p?.shortName || p?.project_name || p?.name || "";

export const projectIdOf = (p) => p?.id || p?.project_id || "";

export const idsEqual = (a, b) =>
  String(a ?? "").trim().toLowerCase() === String(b ?? "").trim().toLowerCase() && String(a ?? "").trim() !== "";

export const findProjectForTender = (tender, projects = []) => {
  if (!tender || !Array.isArray(projects) || !projects.length) return null;
  const keys = [tender.id, tender.tender_id, tender.tenderid, tender.project_code]
    .map((v) => String(v || "").trim().toLowerCase())
    .filter(Boolean);
  const name = String(tender.tender_name || tender.name || "").trim().toLowerCase();

  const byId = projects.find((p) => {
    const candidates = [
      p.id,
      p.project_id,
      p.tender_id,
      p.tender,
      p.bd_tender_id,
      p.source_tender_id,
      p.project_code,
      p.code,
      p.tender_detail?.id,
      p.tender_detail?.tender_id,
    ]
      .map((v) => String(v || "").trim().toLowerCase())
      .filter(Boolean);
    return keys.some((k) => candidates.includes(k));
  });
  if (byId) return byId;

  if (!name) return null;
  return (
    projects.find((p) => {
      const pname = projectDisplayName(p).toLowerCase();
      return pname && (pname === name || pname.includes(name) || name.includes(pname));
    }) || null
  );
};
